<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import HelloWorld from './components/HelloWorld.vue'
	import index from './components/index.vue'
	import axios from 'axios'
	export default {
		name: 'app',
		components: {
			HelloWorld,
			index
		}
	}
</script>

<style>
	body {
		width: 1920px;
		height: 1080px;
		display: flex;
		margin: 0px auto;
		position: relative;
		justify-content: center;
		background-color: #000128;
		
	}
	#app {
		/* font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50; */
		
	}
</style>